import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import rootReducer from './reducer'

export function storeConfig() {
    return createStore(rootReducer, applyMiddleware(thunk))
}